import styles from "./styles.module.scss";
import { goalMapping } from "../../utils/goalMapping";
import { Body, Dumbbell, Scale2, Target } from "@assets/Icons";
import { useSelector } from "react-redux";
import { WALKY_KEYS } from "src/routes/onboarding/shared/constants/walkyKeys";

const GOAL_MAP = {
  WEIGHT_LOSS: "Lose weight",
  IMPROVE_HEART: "Improve heart health",
  GET_TONED: "Get firm and toned",
  DE_STRESS: "Relieve stress",
  LOWER_AGE: "Lower biologocal age",
};

const ACTIVITY_LEVEL = {
  BEGINNER: "Beginner",
  INTERMEDIATE: "Intermediate",
  MODERATELY_ACTIVE: "Moderately active",
  HIGHLY_ACTIVE: "Highly active",
};

export const Metrics = ({ variant }) => {
  const questions = useSelector((state) => state.user?.userInfo?.questions);
  const hopeToAchieve = localStorage.getItem(WALKY_KEYS.hopeToAchieve);

  const hopeToAchieveValue = hopeToAchieve
    ? JSON.parse(hopeToAchieve).includes("WEIGHT_LOSS")
      ? GOAL_MAP.WEIGHT_LOSS
      : GOAL_MAP[JSON.parse(hopeToAchieve)[0]]
    : GOAL_MAP.WEIGHT_LOSS;

  const isWalky = variant === "walky";
  const user = useSelector((state) => state.user?.userInfo);
  const bodyMassType = user?.fitnessProfile?.bodyMassType;
  const fitnessLevel = user?.fitnessProfile?.fitnessLevel;

  const goal = goalMapping[user?.questions?.qqGoal] || GOAL_MAP.WEIGHT_LOSS;
  const ms = localStorage.getItem("ms");

  const weightGoal =
    ms === "us"
      ? user?.questions?.qqGoalWeightLbs
      : user?.questions?.qqGoalWeightKg;

  return (
    <div className={styles.goals}>
      <div className={styles.goalsWrapper}>
        <div className={styles.goalItem}>
          <div className={styles.icon}>
            <Target isWalky={isWalky} />
          </div>
          <div className={styles.text}>
            <p>Goal</p>
            <span>{hopeToAchieveValue}</span>
          </div>
        </div>
        <div className={styles.goalItem}>
          <div className={styles.icon}>
            <Dumbbell isWalky={isWalky} />
          </div>
          <div className={styles.text}>
            <p>Difficulty</p>
            {isWalky ? (
              <span>
                {ACTIVITY_LEVEL[questions?.qqActivityLevel] || "Beginner"}
              </span>
            ) : (
              <span>{fitnessLevel?.toLowerCase() || "Beginner"}</span>
            )}
          </div>
        </div>
      </div>

      <div className={styles.divider}></div>
      <div className={styles.goalsWrapper}>
        <div className={styles.goalItem}>
          <div className={styles.icon}>
            <Body isWalky={isWalky} />
          </div>
          <div className={styles.text}>
            <p>Body type</p>
            <span>{bodyMassType?.toLowerCase()}</span>
          </div>
        </div>
        <div className={styles.goalItem}>
          <div className={styles.icon}>
            <Scale2 isWalky={isWalky} />
          </div>
          <div className={styles.text}>
            <p>Weight goal</p>
            <span>
              {weightGoal} {ms === "us" ? "lbs" : "kg"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
